import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { ITaskSummary } from '@fi-shared/fi-task-shared/tasks-status/tasks-status';
import { TasksStatusType } from '@fi-shared/fi-task-shared/tasks-status/tasks-status-type';
import { AppTextService } from '@fi-shared/app-text';
import { ChartOptions } from 'chart.js';

@Component({
    selector: 'fi-tasks-status-summary',
    templateUrl: './tasks-status-summary.component.html',
    styleUrls: ['./tasks-status-summary.component.scss', '../common-code/tasks-status-card-base.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-tasks-status-summary' },
    standalone: false,
})
export class TasksStatusSummaryComponent implements OnInit, OnChanges {
    @Input() tasksSummary: ITaskSummary[];

    chartData: number[];
    chartColors: string[];
    chartLabels: string[];
    chartOptions: ChartOptions<'doughnut'> = {
        cutout: '75%',
        animation: {
            duration: 1500,
            //easing: 'easeOutBounce'
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    font: {
                        size: 16,
                    },
                },
            },
        },
    };

    constructor(private appTextService: AppTextService) {}

    ngOnInit() {}

    getStatusTypeText(statusType: TasksStatusType) {
        if (statusType === TasksStatusType.InProgress) return this.appTextService.get('task.in_progress'); // SWE plural
        if (statusType === TasksStatusType.Overdue) return this.appTextService.get('task.overdue');
        if (statusType === TasksStatusType.Completed) return this.appTextService.get('common.completed');
        if (statusType === TasksStatusType.Archived) return this.appTextService.get('task.archived_tasks');
        throw new Error('wrong TasksStatusType ' + statusType);
    }

    getStatusTypeColor(statusType: TasksStatusType) {
        if (statusType === TasksStatusType.InProgress) return '#FFC107';
        if (statusType === TasksStatusType.Overdue) return '#f44336';
        if (statusType === TasksStatusType.Completed) return '#5aaf4b';
        throw new Error('wrong TasksStatusType ' + statusType);
    }

    ngOnChanges(changes: SimpleChanges): void {
        let change = changes.tasksSummary;
        if (change) {
            this.updateChartData();
        }
    }

    private updateChartData() {
        this.chartData = [];
        this.chartLabels = [];
        this.chartColors = [];
        this.tasksSummary
            .filter((item) => item.statusType !== TasksStatusType.Archived)
            .forEach((item) => {
                this.chartData.push(item.count);
                this.chartLabels.push(this.getStatusTypeText(item.statusType));
                this.chartColors.push(this.getStatusTypeColor(item.statusType));
            });
    }
}
